import type { Arrow } from '../types';
import { dmg } from '../model/game';

export const arrows: Arrow[] = [
  { type: 'arrow', id: 'ArrowWood', tier: 1, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 22 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowFire', tier: 1, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 11, fire: 22 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowFlint', tier: 1, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 26 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowBronze', tier: 2, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 32 }), knockback: 10,
  },
  { type: 'bolt', id: 'BoltBone', tier: 2, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 32 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowIron', tier: 3, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 42 }), knockback: 10,
  },
  { type: 'bolt', id: 'BoltIron', tier: 3, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 42 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowSilver', tier: 4, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 52, spirit: 20 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowObsidian', tier: 4, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 52 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowPoison', tier: 4, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 26, poison: 52 }), knockback: 10,
  },
  { type: 'arrow', id: 'ArrowFrost', tier: 4, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 26, frost: 52 }), knockback: 10,
  },
  { type: 'bolt', id: 'BoltBlackmetal', tier: 5, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 62 }), knockback: 10,
  },  
  { type: 'arrow', id: 'ArrowNeedle', tier: 5, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 62 }), knockback: 15,
  },
  { type: 'arrow', id: 'ArrowCarapace', tier: 6, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 72 }), knockback: 15,
  },
  { type: 'bolt', id: 'BoltCarapace', tier: 6, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 72 }), knockback: 15,
  },
  { type: 'missile', id: 'TurretBoltWood', tier: 6, weight: 0.5, stack: 20,
    damage: dmg({ pierce: 60 }), knockback: 45,
  },
  { type: 'missile', id: 'TurretBolt', tier: 6, weight: 0.5, stack: 20,
    damage: dmg({ pierce: 100 }), knockback: 50,
  },
  { type: 'arrow', id: 'ArrowCharred', tier: 7, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 82 }), knockback: 15,
  },
  { type: 'bolt', id: 'BoltCharred', tier: 7, weight: 0.1, stack: 100,
    damage: dmg({ pierce: 82 }), knockback: 0,
  },
  { type: 'missile', id: 'TurretBoltFlametal', tier: 7, weight: 0.5, stack: 100,
    damage: dmg({ pierce: 140 }), knockback: 60,
  },
  /*{ type: 'ammo', id: 'draugr_arrow', tier: -1, weight: 1, stack: 20,
    damage: dmg({ pierce: 15 }), knockback: 35,
  },*/
];

for (const arrow of arrows) {
  arrow.components = ['ItemDrop'];
}
